import {GraphNode} from "@cm/graph-v3"
import {ScalarMath} from "#material/nodes/converter/scalar-math/scalar-math"
import {materialConnection} from "#material/nodes/base/connection/shorthand"
import type {InputMaterialConnection, OutputMaterialConnection} from "#material/sockets/definition"
import type {FloatOutput} from "#material/types/common-return-types"
import type {ScalarMathNodeOperation} from "#material/nodes/converter/scalar-math/constants"

export function mathOp(
    operation: ScalarMathNodeOperation,
    a: number | InputMaterialConnection<"float"> | undefined,
    b: number | InputMaterialConnection<"float"> | undefined,
    clamp: boolean | undefined | null = undefined,
): FloatOutput {
    return materialConnection(
        new ScalarMath({
            parameters: {
                inputs: {
                    value: a instanceof GraphNode ? a : undefined,
                    value_001: b instanceof GraphNode ? b : undefined,
                },
                settings: {
                    operation: operation,
                    useClamp: clamp ?? undefined,
                    value: a instanceof GraphNode ? undefined : a,
                    value_001: b instanceof GraphNode ? undefined : b,
                },
            },
        }),
        "value",
    )
}

export const add = (a: number | InputMaterialConnection<"float">, b: number | InputMaterialConnection<"float">): OutputMaterialConnection<"float"> => {
    return materialConnection(
        new ScalarMath({
            parameters: {
                inputs: {
                    value: a instanceof GraphNode ? a : undefined,
                    value_001: b instanceof GraphNode ? b : undefined,
                },
                settings: {
                    operation: "ADD",
                    value: a instanceof GraphNode ? undefined : a,
                    value_001: b instanceof GraphNode ? undefined : b,
                },
            },
        }),
        "value",
    )
}

export const div = (a: number | InputMaterialConnection<"float">, b: number | InputMaterialConnection<"float">): OutputMaterialConnection<"float"> => {
    return materialConnection(
        new ScalarMath({
            parameters: {
                inputs: {
                    value: a instanceof GraphNode ? a : undefined,
                    value_001: b instanceof GraphNode ? b : undefined,
                },
                settings: {
                    operation: "DIVIDE",
                    value: a instanceof GraphNode ? undefined : a,
                    value_001: b instanceof GraphNode ? undefined : b,
                },
            },
        }),
        "value",
    )
}

export const gt = (a: number | InputMaterialConnection<"float">, b: number | InputMaterialConnection<"float">): OutputMaterialConnection<"float"> => {
    return materialConnection(
        new ScalarMath({
            parameters: {
                inputs: {
                    value: a instanceof GraphNode ? a : undefined,
                    value_001: b instanceof GraphNode ? b : undefined,
                },
                settings: {
                    operation: "GREATER_THAN",
                    value: a instanceof GraphNode ? undefined : a,
                    value_001: b instanceof GraphNode ? undefined : b,
                },
            },
        }),
        "value",
    )
}

export const mul = (a: number | InputMaterialConnection<"float">, b: number | InputMaterialConnection<"float">): OutputMaterialConnection<"float"> => {
    return materialConnection(
        new ScalarMath({
            parameters: {
                inputs: {
                    value: a instanceof GraphNode ? a : undefined,
                    value_001: b instanceof GraphNode ? b : undefined,
                },
                settings: {
                    operation: "MULTIPLY",
                    value: a instanceof GraphNode ? undefined : a,
                    value_001: b instanceof GraphNode ? undefined : b,
                },
            },
        }),
        "value",
    )
}

export const sub = (a: number | InputMaterialConnection<"float">, b: number | InputMaterialConnection<"float">): OutputMaterialConnection<"float"> => {
    return materialConnection(
        new ScalarMath({
            parameters: {
                inputs: {
                    value: a instanceof GraphNode ? a : undefined,
                    value_001: b instanceof GraphNode ? b : undefined,
                },
                settings: {
                    operation: "SUBTRACT",
                    value: a instanceof GraphNode ? undefined : a,
                    value_001: b instanceof GraphNode ? undefined : b,
                },
            },
        }),
        "value",
    )
}

export const square = (a: number | InputMaterialConnection<"float">): OutputMaterialConnection<"float"> => {
    return materialConnection(
        new ScalarMath({
            parameters: {
                inputs: {
                    value: a instanceof GraphNode ? a : undefined,
                    value_001: a instanceof GraphNode ? a : undefined,
                },
                settings: {
                    operation: "MULTIPLY",
                    value: a instanceof GraphNode ? undefined : a,
                    value_001: a instanceof GraphNode ? undefined : a,
                },
            },
        }),
        "value",
    )
}

export const sqrt = (a: number | InputMaterialConnection<"float">): OutputMaterialConnection<"float"> => {
    return materialConnection(
        new ScalarMath({
            parameters: {
                inputs: {value: a instanceof GraphNode ? a : undefined},
                settings: {
                    operation: "SQRT",
                    value: a instanceof GraphNode ? undefined : a,
                },
            },
        }),
        "value",
    )
}
